import { useState } from 'react';
import Button from '../Button/ButtonComponent';
import ModalComponent from '../Modal';
import styles from './BottomBarCancel.module.scss';
import { useRouter } from 'next/router';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useRedl } from 'hooks/useRedl';
import LayoutChangesTmpStorageService from 'context/REDL/layoutChangesTmpStorageService';

export default function BottomBarCancelComponent() {
    const router = useRouter();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { redlDatabaseStructure, hidePreview } = useRedl();
    const { getRedlPageMetadata, setRedlRenderableInfo, setIsPageRawLayoutShouldBeStored, clearLayoutChangesTmpStorage } = useRedlMetadata(router.pathname);
    const hasChanges = !getRedlPageMetadata()?.isReset;

    const hideModal = () => {
        setIsModalVisible(false);
    };

    const onCancel = () => {
        if (hasChanges) {
            setIsModalVisible(true);
            clearLayoutChangesTmpStorage();
        }
    };

    const onCancelConfirm = () => {
        hideModal();
        setRedlRenderableInfo(redlDatabaseStructure, true);
        clearLayoutChangesTmpStorage();
    };

    return (
        <>
            <Button variant="tertiary" size="md" disabled={!hasChanges || hidePreview} onClick={onCancel} data-testid="REDL-bottom-bar-reinicia-button">
                Reinicia
            </Button>
            <ModalComponent show={isModalVisible} hideModal={hideModal}>
                <div className={styles.modalWrapper}>
                    <p className={styles.modalTitle}>
                        Estàs segur que vols cancel·lar els canvis realitzats? No es desaran les modificacions i es
                        tornarà a la versió anterior.
                    </p>
                    <div className={styles.modalButtonsWrapper}>
                        <Button variant="tertiary" size="sm-lg" onClick={hideModal} data-testid="REDL-modal-cancel-button">Cancel·la</Button>
                        <Button variant="primary" size="sm-lg" onClick={onCancelConfirm} data-testid="REDL-modal-confirm-button">Confirmar</Button>
                    </div>
                </div>
            </ModalComponent>
        </>
    );
}